import React from 'react';
import logo from '../../logo-tagline.png';
import { Loader } from 'semantic-ui-react';

const Splash = (props) => {
    return (
        <div>
            <div style={{ textAlign: 'center', marginTop: 'clamp(40px, 15vh, 130px)', marginBottom: 10, padding: '0 24px' }}>
                <img src={logo} style={{ width: '90vw', maxWidth: 300 }} alt="logo" />
            </div>
            {props.showLoader && <Loader active inline="centered" size="massive"></Loader>}
        </div>
    );
};

export default Splash;
